import {
  CreateFlagHasPotentialTripBulkInput,
  CreateFlagHasPotentialTripInput,
  CreateFlagHasPotentialTripResponse,
} from '@/models/gen/graphql';
import { validateObj } from '@/utils/custom';

import { CreateFlagHasPotentialTripBulkDocument } from '@/api/queries';
import { GraphApiResponse } from '@/api/core';
import createGraphApiHook from '@/hooks/createGraphApiHook';
import graphApi from '@/api';

const validateFlagHasPotentialTrip = validateObj({
  flagId: (val: string): string => val || '',
  potentialTripId: (val: string): string => val || '',
});

type CreateFlagHasPotentialTripBulkGraphApiResponse = GraphApiResponse<typeof CreateFlagHasPotentialTripBulkDocument>;

const createFlagHasPotentialTripBulkResponseSelector = (
  res: CreateFlagHasPotentialTripBulkGraphApiResponse
): CreateFlagHasPotentialTripResponse[] =>
  !res.errors ? ((res?.createFlagHasPotentialTripBulk?.output || []) as CreateFlagHasPotentialTripResponse[]) : undefined;

const [runCreateFlagHasPotentialTripBulk] = graphApi(CreateFlagHasPotentialTripBulkDocument);

const createFlagHasPotentialTripBulk = async (
  flagHasPotentialTrips: CreateFlagHasPotentialTripInput[]
): Promise<CreateFlagHasPotentialTripResponse[]> => {
  const input: CreateFlagHasPotentialTripBulkInput = { values: flagHasPotentialTrips.map(validateFlagHasPotentialTrip) };

  const res = await runCreateFlagHasPotentialTripBulk({ input });
  const selected = createFlagHasPotentialTripBulkResponseSelector(res);

  return selected;
};

export const useCreateFlagHasPotentialTripBulk = createGraphApiHook(createFlagHasPotentialTripBulk);

export default createFlagHasPotentialTripBulk;
